// src/pages/SRJAbhiyan.js
import React from "react";

export default function SRJAbhiyan() {
  const styles = {
    container: {
      padding: "20px",
      maxWidth: "900px",
      margin: "0 auto",
      fontFamily: "Arial, sans-serif",
      lineHeight: "1.6",
      color: "#333",
    },
    heading: {
      textAlign: "center",
      marginBottom: "20px",
      color: "#2c3e50",
    },
    section: {
      marginBottom: "20px",
    },
    list: {
      paddingLeft: "20px",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>महात्मा गांधी राष्ट्रीय ग्रामीण रोजगार हमी योजना</h1>

      <div style={styles.section}>
        <h2>प्रस्तावना</h2>
        <p>
          भारत हा कृषी प्रधान देश आहे. भारतामध्ये कधी कमी पाऊस तर कधी जास्त पाऊस पडत असते. 
          त्यामुळे जीवनमान जगताना अनेक संकटांना लोकांना सामोरे जावे लागते.
        </p>
        <p>
          महाराष्ट्र राज्यात सन १९७२ ला भीषण दुष्काळ पडला. गावातील लोकांना रोजगार मिळत नव्हता. उपासमारीची वेळ निर्माण झाली. 
          तत्कालीन आमदार वि.स.पागे यांनी गावातील लोकांना रोजगार मिळावा, पलायन थांबावे, रोजगाराची शाश्वत निर्मिती व्हावी या उद्देशाने महाराष्ट्र रोजगार हमी अधिनियम १९७७ अन्वये रोजगार हमी योजना कार्यान्वित केली.
        </p>
      </div>

      <div style={styles.section}>
        <h2>योजनेचे उद्देश</h2>
        <p>
          तत्कालीन महाराष्ट्र विधानपरिषद सदस्य श्री.वि.स.पागे यांच्या संकल्पनेतून रोजगार हमी योजनेचा जन्म झाला. 
          ग्रामीण भागाचे टिकाऊ विकास साधणे, मानव साधन संपत्ती टिकवणे आणि अकुशल मजुरांना रोजगार उपलब्ध करणे या उद्देशाने केंद्र सरकारने राष्ट्रीय रोजगार हमी अधिनियम २००५ पारित केला.
        </p>
      </div>

      <div style={styles.section}>
        <h2>ध्येय</h2>
        <ul style={styles.list}>
          <li>मजुरीच्या रोजगाराच्या संधीची हमी देऊन ग्रामीण भारतातील सर्वात असुरक्षित लोकांसाठी सामाजिक संरक्षण</li>
          <li>टिकाऊ मालमत्तेची निर्मिती करून गरिबांच्या उपजीविकेची सुरक्षा वाढविणे</li>
          <li>ग्रामीण भागातील नैसर्गिक साधन संपत्तीचे पुनर्जीवन करणे</li>
          <li>टिकाऊ व उत्पादक मालमत्ता निर्माण करणे</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2>ग्रामपंचायतीच्या जबाबदाऱ्या</h2>
        <ul style={styles.list}>
          <li>कुटुंबाची नोंदणी</li>
          <li>सामाजिक अंकेक्षण व पारदर्शकता</li>
          <li>दक्षता समिती</li>
          <li>रोजगार दिवस</li>
          <li>ग्रामसभेमध्ये रोजगार भिमुख आराखडा तयार करून प्राधान्यक्रम ठरविणे</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2>कामांचे प्रकार</h2>
        <h3>सार्वजनिक स्वरुपाची कामे:</h3>
        <ul style={styles.list}>
          <li>पांदन रस्ते</li>
          <li>तलावातील गाळ काढणे</li>
          <li>नाला खोलीकरण/सरळीकरण</li>
          <li>वृक्ष लागवड</li>
          <li>मातीनाला बंध</li>
          <li>मैदान सपाटीकरण</li>
        </ul>

        <h3>वैयक्तिक स्वरुपाची कामे:</h3>
        <ul style={styles.list}>
          <li>सिंचन विहीर</li>
          <li>गुरांचा गोठा</li>
          <li>शेळीचा गोठा</li>
          <li>कुक्कुटपालन शेड</li>
          <li>भात खाचरे /मजगी</li>
          <li>फळबाग</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2>मजुरांचे अधिकार</h2>
        <h3>कामाची मागणी:</h3>
        <ul style={styles.list}>
          <li>कामाची मागणी केव्हाही करता येऊ शकते</li>
          <li>काम मागणी नंतर १५ दिवसांत काम सुरु झाले पाहिजे</li>
          <li>१५ दिवसात काम मिळाले नाही तर बेरोजगार भत्ता मिळण्याचा अधिकार</li>
        </ul>

        <h3>मजुरी संबंधित:</h3>
        <ul style={styles.list}>
          <li>सर्व मजुरांना मान्य नियमानुसार मजुरीचा दर</li>
          <li>स्त्री मजूर व पुरुष मजूर यांना समान वेतन</li>
          <li>मजुरी आठवड्याला किंवा जास्तीत जास्त १५ दिवसांनी मिळणे बंधनकारक</li>
        </ul>

        <h3>तक्रार निवारण:</h3>
        <ul style={styles.list}>
          <li>ग्रामपंचायत किंवा पंचायत समिती येथे तक्रार नोंदविणे</li>
          <li><a href="https://www.nrega.nic.in" target="_blank" rel="noopener noreferrer">www.nrega.nic.in</a> या वेबसाईटवर तक्रार</li>
          <li>टोल फ्री क्रमांक: 1800-22-3839</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2>घोषवाक्य</h2>
        <p>"मागेल त्याला काम, मागेल तेव्हा काम, मागेल तितके काम, पाहिजे ते काम, केलेल्या कामाचे दाम"</p>
      </div>
    </div>
  );
}
